import { Box } from '@mui/joy';

import { CorporatePartSetUpList } from 'corporate/components/CorporatePartSetUp';
import { ICorporatePart } from 'corporate/types';

import { PartDetailsTab } from '../enums';
import { usePartDetailsScrollToFocus } from '../hooks';

interface IProps {
  corporatePart?: Partial<ICorporatePart> | null;
  partNumber: string;
  manufacturerId: number;
  fullWidth?: boolean;
  isLoading?: boolean;
}

export const SetUp = (props: IProps) => {
  const { panelScrollAnchorRef } = usePartDetailsScrollToFocus(PartDetailsTab.SET_UP);

  return (
    <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
      <CorporatePartSetUpList {...props} scrollableContent />
    </Box>
  );
};
